import { ProfileRoleTypes } from '@strength/db-schema';
import {
  CRICKET_BOWLING_COACH_PROFILE_ROLE,
  type ProfileRoleType,
} from '@strength/domain';

export function getProfileRoleLabels(bowlingFlag: boolean): ProfileRoleType[] {
  if (bowlingFlag) return [...ProfileRoleTypes];
  return ProfileRoleTypes.filter(
    (role) => role !== CRICKET_BOWLING_COACH_PROFILE_ROLE,
  );
}
